import { useStateContext } from 'context/StateContext'
import buttonSound from 'assets/sounds/mouse-click.mp3'
import { Link as ReactScroll } from 'react-scroll';
import ltr from 'assets/demos-pictures/ltr.png'
import rtl from 'assets/demos-pictures/rtl.png'
import ltrBlack from 'assets/demos-pictures/ltr-black.png'
import rtlBlack from 'assets/demos-pictures/rtl-black.png'
import './_demos.scss'
import { Link } from 'react-router-dom';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import responsive from 'assets/demos-svg/responsive.svg'
import dark from 'assets/demos-svg/dark.svg'
import sidebar from 'assets/demos-svg/sidebar.svg'
import customize from 'assets/demos-svg/customize.svg'
import transition from 'assets/demos-svg/transition.svg'
import documentation from 'assets/demos-svg/documentation.svg'

// pages
import page1 from 'assets/demos-pictures/page1.png'
import page2 from 'assets/demos-pictures/page2.png'
import page3 from 'assets/demos-pictures/page3.png'
import page4 from 'assets/demos-pictures/page4.png'
import page5 from 'assets/demos-pictures/page5.png'


export default function Index() {
  const { handleButtonSound, buttonSoundRef } = useStateContext()

  return (
    <>
      <audio src={buttonSound} ref={buttonSoundRef}></audio>
      <div id="demo-section-stylling">
        <header>
          <div className="container text-light">
            <div className="row">
              <div className="col-11 col-md-8 col-lg-7">
                <h1>Steven Eric</h1>
                <h5 className='my-5'>A Sleek and Modern Portfolio Template to Showcase Your Professional Journey!</h5>
                <ReactScroll className='btn btn-info button-stylling px-4 py-2 py-md-3 rounded-pill' to='demos' spy={true} smooth={true} duration={500} onClick={handleButtonSound}>View Demos <ExpandMoreOutlinedIcon /></ReactScroll>
              </div>
            </div>
          </div>
        </header>

        {/* main */}
        <main>
          {/* features */}
          <div className="container transition-container py-5">
            <h2 className='text-center mb-5 fw-bold text-decoration-underline'>FEATURES</h2>
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
              <div className="col d-flex">
                <div className="card px-4 py-3 py-sm-4 border-0 shadow-lg rounded-4">
                  <div><img src={responsive} alt="icon" /></div>
                  <h3 className='my-4 fw-bold'>Responsive Design</h3>
                  <p className='text-secondary'>Ensures optimal viewing experience across various devices, from desktops to smartphones.</p>
                </div>
              </div>
              <div className="col d-flex">
                <div className="card px-4 py-3 py-sm-4 border-0 shadow-lg rounded-4">
                  <div><img src={dark} alt="icon" /></div>
                  <h3 className='my-4 fw-bold'>Dark and Light Mode</h3>
                  <p className='text-secondary'>Instantly switch between dark and light modes for a personalized and comfortable browsing experience.</p>
                </div>
              </div>
              <div className="col d-flex">
                <div className="card px-4 py-3 py-sm-4 border-0 shadow-lg rounded-4">
                  <div><img src={sidebar} alt="icon" /></div>
                  <h3 className='my-4 fw-bold'>Sidebar Navigation</h3>
                  <p className='text-secondary'>Convenient sidebar navigation for easy access to different sections and pages.</p>
                </div>
              </div>
              <div className="col d-flex">
                <div className="card px-4 py-3 py-sm-4 border-0 shadow-lg rounded-4">
                  <div><img src={customize} alt="icon" /></div>
                  <h3 className='my-4 fw-bold'>Customizable Elements</h3>
                  <p className='text-secondary'>Easily customize the template to reflect your personal branding and style.</p>
                </div>
              </div>
              <div className="col d-flex">
                <div className="card px-4 py-3 py-sm-4 border-0 shadow-lg rounded-4">
                  <div><img src={transition} alt="icon" /></div>
                  <h3 className='my-4 fw-bold'>Smooth Transitions</h3>
                  <p className='text-secondary'>Incorporates smooth transitions and animations for a seamless user experience.</p>
                </div>
              </div>
              <div className="col d-flex">
                <div className="card px-4 py-3 py-sm-4 border-0 shadow-lg rounded-4">
                  <div><img src={documentation} alt="icon" /></div>
                  <h3 className='my-4 fw-bold'>Code Documentation</h3>
                  <p className='text-secondary'> text-secondaryWell-documented code for easy customization and understanding.</p>
                </div>
              </div>
            </div>
          </div>

          {/* demos */}
          <h2 className='text-center my-5 fw-bold text-decoration-underline ' name="demos">DEMOS</h2>
          <div className="container-fluid">
            <div className="container" >
              <div className="row row-cols-1 row-cols-md-2 g-4">
                <div className="col">
                  <Link to="/left_to_right/home" target="_blank" rel="noopener noreferrer">
                    <div className="card border-info shadow">
                      <div id="carouselExample" className="carousel slide carousel-fade" data-bs-ride="carousel">
                        <div className="carousel-inner">
                          <div className="carousel-item active" data-bs-interval="2000">
                            <img src={ltr} className="card-img-top" alt="..." />
                          </div>
                          <div className="carousel-item" data-bs-interval="2000">
                            <img src={ltrBlack} className="card-img-top" alt="..." />
                          </div>
                        </div>
                        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
                          <span className="carousel-control-prev-icon bg-dark py-4 rounded" aria-hidden="true"></span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
                          <span className="carousel-control-next-icon bg-dark py-4 rounded" aria-hidden="true"></span>
                        </button>
                      </div>
                      <div className="card-body text-center">
                        <h4 className="card-text">LTR</h4>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col">
                  <Link to="/right_to_left/home" target="_blank" rel="noopener noreferrer">
                    <div className="card border-info shadow ">
                      <div id="carouselExample2" className="carousel slide carousel-fade" data-bs-ride="carousel">
                        <div className="carousel-inner">
                          <div className="carousel-item active" data-bs-interval="2000">
                            <img src={rtl} className="card-img-top" alt="..." />
                          </div>
                          <div className="carousel-item" data-bs-interval="2000">
                            <img src={rtlBlack} className="card-img-top" alt="..." />
                          </div>
                        </div>
                        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample2" data-bs-slide="prev">
                          <span className="carousel-control-prev-icon bg-dark py-4 rounded" aria-hidden="true"></span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#carouselExample2" data-bs-slide="next">
                          <span className="carousel-control-next-icon bg-dark py-4 rounded" aria-hidden="true"></span>
                        </button>
                      </div>
                      <div className="card-body text-center">
                        <h4 className="card-text">RTL</h4>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div >
          </div>

          {/* pages */}
          <div className="container py-5">
            <h2 className='text-center mb-5 fw-bold text-decoration-underline'>PAGES</h2>
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3">
              <div className="col">
                <div className="card shadow border-info overflow-hidden">
                  <img src={page1} className='card-img-top' alt="pages_photos" />
                </div>
              </div>
              <div className="col">
                <div className="card shadow border-info overflow-hidden">
                  <img src={page2} className='card-img-top' alt="pages_photos" />
                </div>
              </div>
              <div className="col">
                <div className="card shadow border-info overflow-hidden">
                  <img src={page3} className='card-img-top' alt="pages_photos" />
                </div>
              </div>
              <div className="col">
                <div className="card shadow border-info overflow-hidden">
                  <img src={page4} className='card-img-top' alt="pages_photos" />
                </div>
              </div>
              <div className="col">
                <div className="card shadow border-info overflow-hidden">
                  <img src={page5} className='card-img-top' alt="pages_photos" />
                </div>
              </div>
            </div>
          </div>

        </main >

        {/* footer */}
        <footer className='bg-dark bg-gradient text-center text-light'>
          <div className="container">
            <div className="row pt-4">
              <div className="col">
                <p className='mt-3'>A Sleek and Modern Portfolio Template to Showcase Your Professional Journey!</p>
                <button className='btn btn-outline-info px-0 py-3 shadow'><a href="https://themeforest.net/user/starunittech/portfolio" target='_blank' className='px-5 py-3 text-decoration-none text-light'>Purchase Now</a></button>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col py-3 ">
                Copyright &copy; 2024. All rights reserved.
              </div>
            </div>
          </div>
        </footer >
      </div >
    </>
  )
}
